import { render, staticRenderFns } from "./UserListTargeting.vue?vue&type=template&id=6ec1f832&"
import script from "./UserListTargeting.vue?vue&type=script&lang=js&"
export * from "./UserListTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports